import React, { useEffect, useState, useRef } from 'react';
import '../styles/projectDetail.css';

export default function ProjectDetail({ folder, bucketUrl }) {
  const [data, setData] = useState(null);
  const [images, setImages] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const scrollRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timestamp = Date.now();

    const dataUrl = `${bucketUrl}${folder}/data.json?t=${timestamp}`;
    const imagesUrl = `${bucketUrl}${folder}/images.json?t=${timestamp}`;

    Promise.all([
      fetch(dataUrl).then(res => res.json()),
      fetch(imagesUrl).then(res => res.json())
    ])
      .then(([meta, imageList]) => {
        setData(meta);

        const thumb = meta.thumbnail;
        const allImages = [thumb, ...imageList.filter(img => img !== thumb)];

        Promise.all(
          allImages.map(src => {
            return new Promise(resolve => {
              const img = new Image();
              img.src = `${bucketUrl}${folder}/${src}`;

              img.onload = () => {
                const orientation =
                  img.naturalWidth >= img.naturalHeight
                    ? "horizontal"
                    : "vertical";
                resolve({ src, orientation });
              };

              img.onerror = () => {
                resolve({ src, orientation: "horizontal" });
              };
            });
          })
        ).then(imgs => {
          setImages(imgs);
          setVisible(true);
        });
      })
      .catch(err => console.error("Error loading project detail:", err));
  }, [folder, bucketUrl]);

  const smoothScroll = (element, distance) => {
    const duration = 600;
    const start = element.scrollLeft;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 0.5 * (1 - Math.cos(Math.PI * progress));
      element.scrollLeft = start + distance * ease;

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  };

  if (!data) return null;
  console.log("RENDERING NAME:", data.name);
const sentenceCase = (str = "") =>
  str
    .trim()
    .split(" ")
    .map(word =>
      word
        .split("-")
        .map(part =>
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        )
        .join("-")
    )
    .join(" ");
  return (
    <div className={`detail-scroll-wrapper ${visible ? "show" : ""}`}>

      {/* DESKTOP ONLY — FIXED CARD */}
      {isDesktop && (
        <div className="detail-metadata-card fixed">
          <h2>{sentenceCase(data.name)}</h2>
          <p><strong>Year:</strong> {data.Year}</p>
          <p><strong>Status:</strong> {data.Status}</p>
          <p><strong>Type:</strong> {data.type}</p>
            <p><strong>Location:</strong> {data.location}</p>
            <p><strong>Area:</strong> {data.Area}</p>
          <p className="mobile_card"> {data.brief}</p>
        </div>
      )}

      <button className="scroll-arrow left" onClick={() => smoothScroll(scrollRef.current, -400)}>‹</button>

      <div className="detail-horizontal" ref={scrollRef}>

        {/* Thumbnail */}
        {images.length > 0 && (
          <img
            src={`${bucketUrl}${folder}/${images[0].src}`}
            alt=""
            className={`detail-scroll-image ${images[0].orientation}`}
          />
        )}

        {/* MOBILE: Metadata card inside scroll */}
        {!isDesktop && (
          <div className="detail-metadata-card">
            <h2>{sentenceCase(data.name)}</h2>
          <p><strong>Year:</strong> {data.Year}</p>
          <p><strong>Status:</strong> {data.Status}</p>
          <p><strong>Type:</strong> {data.type}</p>
            <p><strong>Location:</strong> {data.location}</p>
            <p><strong>Area:</strong> {data.Area}</p>
          <p className="mobile_card"> {data.brief}</p>
          </div>
        )}

        {/* Remaining images */}
        {images.slice(1).map(({ src, orientation }, i) => (
          <img
            key={i}
            src={`${bucketUrl}${folder}/${src}`}
            alt=""
            className={`detail-scroll-image ${orientation}`}
          />
        ))}
      </div>

      <button className="scroll-arrow right" onClick={() => smoothScroll(scrollRef.current, 400)}>›</button>
    </div>
  );
}
